import type { FaireThemeEntity } from "../../entity_types/theme";

export const the_gift_shop_snack_corner: FaireThemeEntity = {
  token: "the-gift-shop-snack-corner",
  type: "theme",
  name: "The Gift Shop Snack Corner",
  description: "Round out your snack aisle with these fruity and sweet drink options. These additions pair perfectly with your existing stock of gourmet chips and international chocolates.",
  teaser: "You frequently order snack-related items such as Rap Snacks, Milka cookies, and Kinder chocolate. These new beverage choices help complete your food and drink category.",
  detail: "The additional_context payload supports this theme because it contains True Life Peach Juice and Arizona Sweet Tea, which cater to the same 'sweet treat' interest seen in your past orders of Milka and Kinder products.",
  bgColor: "#E8D4E8",
  tileBgColor: "#6b3838",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_v4g82895nb",
    "p_kn4qbt59zj",
    "p_9q9fjnmkhh",
    "p_u9jtx4ts3a",
    "p_prguw9vwjy",
    "p_9bacm33g6k",
    "p_4p7ygdj8yr",
    "p_u89h2h4qq2",
    "p_gxbr5te2gx",
    "p_f3yxgc29pu",
    "p_k7r3rtr8vh",
    "p_yecgvaauy3",
    "p_mnubrpyau7",
    "p_8nk7eetr3n",
    "p_tse9ygx6fp",
    "p_535bv2wvzp",
    "p_ctqfbth8ev",
    "p_jza9nqtbws",
    "p_xnnfex2twa",
    "p_yuweerx42e",
    "p_rrq936cxhr",
    "p_6dbuhze2n5",
    "p_hnfmpw2q3y",
    "p_ch9vr3fnxe",
    "p_ykmex5bwyz",
    "p_72xm8ygn4y",
    "p_qd2d3ntp4w",
    "p_9nre38ns26",
    "p_g3syszptaw",
    "p_fft6u3mzqw",
    "p_2vhmffepct",
    "p_s9evtgex34",
    "p_cbwragr2f6",
    "p_hpb7sjvh6x",
    "p_7ehm9uwt6f",
    "p_nxgeqkuueg",
    "p_fd9wq5dfcz",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
